export default {
    CREATE_PDF: "CREATE_PDF",
    COMPLETE_FORM: "COMPLETE_FORM",
    COMPLETE_TASK: "COMPLETE_TASK",
    GO_TO_STEP: "GO_TO_STEP",
    DISPLAY_FEEDBACK: "DISPLAY_FEEDBACK",
    LOAD_URL: "LOAD_URL",
    LOAD_FORM: "LOAD_FORM",
    IMPORT: "IMPORT",
    SEND_EMAIL: "SEND_EMAIL",
    START_PROCESS: "START_PROCESS",
    STORE_DATA: "STORE_DATA",
    WRITE_TO_TABLE: "WRITE_TO_TABLE"
}
